export default __webpack_public_path__ + "static/media/ico-home-buyer-black.6c2f5891.svg";